module.exports = __webpack_public_path__ + "img/1954.f205549b.svg";